import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import FoodOrder from "./pages/FoodOrder";
import MenuEditor from "./pages/MenuEditor";
import RoomBooking from "./pages/RoomBooking";
import CarHire from "./pages/CarHire";
import Laundry from "./pages/Laundry";
import Dashboard from "./pages/Dashboard";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/order" element={<FoodOrder />} />
        <Route path="/menu" element={<MenuEditor />} />
        <Route path="/rooms" element={<RoomBooking />} />
        <Route path="/carhire" element={<CarHire />} />
        <Route path="/laundry" element={<Laundry />} />
        <Route path="/kitchen" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
